import React from 'react';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

function Address() {
  return (
    <>
      <Text styles={[styles.addressText, styles.first]}>Norwegian Block Exchange AS</Text>
      <Text styles={[styles.addressText]}>
        Organization number:
        <br />
        920245676
      </Text>
      <Text styles={[styles.addressText]}>
        Business address:
        <br />
        Snarøyveien 36
        <br />
        1364 FORNEBU
        <br />
        Norway
      </Text>
    </>
  );
}

export default Address;
